import { createContext, type ReactNode, useContext, useMemo } from "react";

interface RecoveryNotice {
  id: string;
  content: ReactNode;
}

const RecoveryNoticesContext = createContext<readonly RecoveryNotice[]>([]);

/** Make recovery actions available inside any open, focus-trapped dialog. */
export function RecoveryNoticesProvider({
  children,
  notice,
}: {
  children: ReactNode;
  notice: RecoveryNotice | null;
}) {
  const inherited = useContext(RecoveryNoticesContext);
  const notices = useMemo(
    () => (notice ? [...inherited, notice] : inherited),
    [inherited, notice],
  );
  return (
    <RecoveryNoticesContext.Provider value={notices}>
      {children}
    </RecoveryNoticesContext.Provider>
  );
}

export const useRecoveryNotices = () => useContext(RecoveryNoticesContext);
